import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { resolveImagePath } from '@/utils/imageMap';
import Header from '@/components/layout/Header';
import { Hero } from '@/components/sections/Hero.tsx';
import { AboutNarrative } from '@/components/sections/AboutNarrative.tsx';
import { ServicesDetail } from '@/components/sections/ServicesDetail.tsx';
import { AppointmentCta } from '@/components/sections/AppointmentCta.tsx';
import { Specials } from '@/components/sections/Specials.tsx';
import { Contact } from '@/components/sections/Contact.tsx';
import { FooterBranding } from '@/components/sections/FooterBranding.tsx';
import heroData from '@/data/hero.json';
import aboutNarrativeData from '@/data/aboutNarrative.json';
import servicesDetailData from '@/data/servicesDetail.json';
import appointmentCtaData from '@/data/appointmentCta.json';
import specialsData from '@/data/specials.json';
import contactData from '@/data/contact.json';
import footerBrandingData from '@/data/footerBranding.json';

export function Index() {
  const { siteData } = useSiteData();
  const ogImageUrl = siteData.ogImage ? resolveImagePath(siteData.ogImage) : undefined;

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        
        {siteData.canonicalUrl && (
          <link rel="canonical" href={siteData.canonicalUrl} />
        )}
        
        {/* Open Graph tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        {siteData.canonicalUrl && (
          <meta property="og:url" content={siteData.canonicalUrl} />
        )}
        <meta property="og:site_name" content="Good News Garage" />
        {ogImageUrl && (
          <meta property="og:image" content={ogImageUrl} />
        )}
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <Header />
        
        <main>
          <Hero data={heroData} />
          <AboutNarrative data={aboutNarrativeData} />
          <ServicesDetail data={servicesDetailData} />
          <AppointmentCta data={appointmentCtaData} />
          <Specials data={specialsData} />
          <Contact data={contactData} />
        </main>
        
        <FooterBranding data={footerBrandingData} />
      </div>
    </>
  );
}